import { useState, useRef } from 'react';
import {
  Box,
  Card,
  Table,
  Typography,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Tooltip,
  Stack,
  TableContainer,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

import {
  CustomIconButton,
  DefaultContainedButton,
  DefaultContainedLoadingButton,
  DefaultOutlinedButton,
  RedOutlinedLoadingButton,
} from '../../Buttons';
import { LoadingUI } from '../../LayoutStyles';
import { useStandDocumentUpload } from '../../../hooks/useStandDocumentUpload';
import { DecisionDialog } from '../../DecisionDialog';

export default function StandsCard({
  stands,
  isStandApiCalled,
  handleOpenStandHandlerDialog,
  disabledButton,
  refreshStandsList,
  showSnackbar,
  setSnackbarText,
  canEdit,
}) {
  const {
    selectedItem,
    setSelectedItem,
    document,
    setDocument,
    uploadRef,
    uploading,
    deleting,
    handleUpload,
    handleDelete,
    cdnUrl,
    copyLink,
    formatSize,
    getIcon,
  } = useStandDocumentUpload({
    refreshList: refreshStandsList,
    showSnackbar,
    setSnackbarText,
  });

  const [openDeleteDocumentDialog, setOpenDeleteDocumentDialog] = useState(false);

  const handleCloseDeleteDocumentDialog = () => {
    setOpenDeleteDocumentDialog(false);
  };

  const handleOpenDeleteDocumentDialog = (stand) => {
    setSelectedItem(stand);
    setOpenDeleteDocumentDialog(true);
  };

  const [openUploadDocumentDialog, setOpenUploadDocumentDialog] = useState(false);

  const handleOpenUploadDocumentDialog = (stand) => {
    setSelectedItem(stand);
    setOpenUploadDocumentDialog(true);
  };

  const handleCloseUploadDocumentDialog = () => {
    setOpenUploadDocumentDialog(false);
    setDocument(null);
  };

  const handleUploadAndClose = async () => {
    await handleUpload('celebration_stands');
    setOpenUploadDocumentDialog(false);
    setDocument(null);
  };

  const handleDeletedAndClose = async () => {
    await handleDelete('celebration_stands');
    setOpenDeleteDocumentDialog(false);
  };

  return (
    <Card sx={{ padding: '24px', maxHeight: '500px', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ mb: '24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h5">Lista Stand</Typography>
        {canEdit && (
          <DefaultContainedButton
            disabled={disabledButton}
            onClick={() => handleOpenStandHandlerDialog(null, 'create')}
          >
            Aggiungi Stand
          </DefaultContainedButton>
        )}
      </Box>

      <Box sx={{ overflowY: 'auto', flexGrow: 1 }}>
        <TableContainer>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>Nome</TableCell>
                <TableCell>Tipo Stand</TableCell>
                <TableCell>Numero</TableCell>
                <TableCell>Gestione Volontari</TableCell>
                <TableCell>Documento</TableCell>
                <TableCell>Etichetta Documento</TableCell>
                <TableCell />

                {canEdit && <TableCell />}
              </TableRow>
            </TableHead>
            <TableBody>
              {isStandApiCalled ? (
                stands.length > 0 ? (
                  stands.map((stand) => (
                    <TableRow key={stand.id}>
                      <TableCell>{stand.title}</TableCell>
                      <TableCell>{stand.stand_type.name}</TableCell>
                      <TableCell>{stand.number}</TableCell>
                      <TableCell>
                        {stand.volunters ? <CheckIcon sx={{ color: 'green' }} /> : <ClearIcon sx={{ color: 'red' }} />}
                      </TableCell>
                      <TableCell>
                        {stand.document_url ? (
                          <Stack direction="row" spacing={1} alignItems="center">
                            <Tooltip title="Visualizza documento" arrow placement="top">
                              <Box>
                                {/* <CustomIconButton onClick={() => openUserEvent(celebration, true)}> */}
                                <a
                                  href={cdnUrl(stand.document_url)}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ textDecoration: 'none' }}
                                >
                                  <CustomIconButton>
                                    <DescriptionOutlinedIcon />
                                  </CustomIconButton>
                                </a>
                              </Box>
                            </Tooltip>
                            <Tooltip title="Copia link documento" arrow placement="top">
                              <Box>
                                <CustomIconButton onClick={() => copyLink(stand.document_url)}>
                                  <ContentCopyIcon />
                                </CustomIconButton>
                              </Box>
                            </Tooltip>
                            {/* {canEdit && (
                            <Tooltip title="Elimina documento" arrow placement="top">
                              <Box>
                                <CustomIconButton onClick={() => handleOpenDeleteDocumentDialog(stand)}>
                                  <DeleteOutlineIcon />
                                </CustomIconButton>
                              </Box>
                            </Tooltip>
                          )} */}
                          </Stack>
                        ) : (
                          <>
                            {/* {canEdit ? (
                            <Stack direction="row" spacing={1} alignItems="center">
                              <Tooltip title="Carica documento" arrow placement="top">
                                <Box>
                                  <CustomIconButton onClick={() => handleOpenUploadDocumentDialog(stand)}>
                                    <FileUploadIcon />
                                  </CustomIconButton>
                                </Box>
                              </Tooltip>
                            </Stack>
                          ) : ( */}
                            <Typography variant="body2">Non disponibile</Typography>
                            {/* )} */}
                          </>
                        )}
                        {/* <Button onClick={() => handleOpenStandDocumentDialog(stand)}>ciao</Button> */}
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2">
                          {stand?.document_url && stand?.document_label ? stand.document_label : 'Non disponibile'}
                        </Typography>
                      </TableCell>
                      {canEdit && (
                        <TableCell>
                          <Stack direction="row" alignItems="center" justifyContent="end">
                            {/* Edit Stand */}
                            <Box>
                              <Tooltip title="Modifica Stand" arrow placement="top">
                                <Box>
                                  <CustomIconButton onClick={() => handleOpenStandHandlerDialog(stand, 'update')}>
                                    <EditIcon />
                                  </CustomIconButton>
                                </Box>
                              </Tooltip>
                            </Box>

                            {/* Delete Stand */}
                            <Box>
                              <Tooltip title="Elimina Stand" arrow placement="top">
                                <Box>
                                  <CustomIconButton onClick={() => handleOpenStandHandlerDialog(stand, 'delete')}>
                                    <DeleteIcon />
                                  </CustomIconButton>
                                </Box>
                              </Tooltip>
                            </Box>
                          </Stack>
                        </TableCell>
                      )}
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={8} sx={{ textAlign: 'center' }}>
                      <Typography variant="span">Nessuno stand assegnato</Typography>
                    </TableCell>
                  </TableRow>
                )
              ) : (
                <TableRow>
                  <TableCell colSpan={8}>{LoadingUI()}</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      <DecisionDialog
        openDialog={openDeleteDocumentDialog}
        dialogTitle="Eliminazione documento"
        dialogDescription={
          <>
            Sei sicuro di voler eliminare il documento dello stand <strong>{selectedItem?.title}</strong>?
          </>
        }
        closeOperation={handleCloseDeleteDocumentDialog}
        requestOperation={() => handleDeletedAndClose()}
        requestText={'Elimina'}
        closeText={'Chiudi'}
        requestButtonElement={<RedOutlinedLoadingButton loading={deleting} />}
      />

      <Dialog open={openUploadDocumentDialog} onClose={handleCloseUploadDocumentDialog} fullWidth>
        <DialogTitle>Carica Documento</DialogTitle>
        <DialogContent>
          {document ? (
            <Stack direction="row" alignItems="center" spacing={2}>
              <Box component="img" src={getIcon(document)} sx={{ width: 48, height: 48, flexShrink: 0 }} />

              <Stack direction="column" sx={{ minWidth: 240, flexGrow: 1 }}>
                <Typography color="inherit" variant="subtitle2" noWrap>
                  {document.name}
                </Typography>

                <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
                  Dimensione file: {formatSize(document.size)}
                </Typography>
              </Stack>
            </Stack>
          ) : (
            <>
              <Button
                sx={{
                  height: '200px',
                  width: '100%',
                  boxShadow: 'none',
                  backgroundColor: '#f4f6f8',
                  color: 'black',
                  '&:hover': {
                    backgroundColor: '#f4f6f8',
                  },
                }}
                variant="contained"
                component="label"
              >
                Upload File
                <input
                  type="file"
                  ref={uploadRef}
                  accept=".pdf,.jpg,.jpeg,.png"
                  style={{ display: 'none' }}
                  onChange={(e) => setDocument(e.target.files[0])}
                />
              </Button>

              <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                La dimensione massima consentita è di 10MB.
              </Typography>
            </>
          )}
        </DialogContent>
        <DialogActions>
          <DefaultOutlinedButton disabled={uploading} onClick={() => handleCloseUploadDocumentDialog()}>
            Annulla
          </DefaultOutlinedButton>
          {document && (
            <DefaultContainedLoadingButton loading={uploading} onClick={() => handleUploadAndClose()}>
              Carica file
            </DefaultContainedLoadingButton>
          )}
        </DialogActions>
      </Dialog>
    </Card>
  );
}
